/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Email_PurposeInputs */



/**
* | output |
* | --- |
* | "What your app does with the email address (shown to the member on consent)" |
*
* @param {Developer_Email_PurposeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_email_purpose = /** @type {((inputs?: Developer_Email_PurposeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Email_PurposeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce que votre application fait de l'adresse e-mail (montré au membre lors du consentement)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Qué hace tu aplicación con el correo electrónico (se muestra al miembro al dar su consentimiento)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O que seu aplicativo faz com o e-mail (mostrado ao membro no consentimento)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cosa fa la tua app con l'indirizzo email (mostrato al membro al momento del consenso)")
	return /** @type {LocalizedString} */ ("What your app does with the email address (shown to the member on consent)")
});